// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
Prebuilt styles for quick use
Basically bootleg bootstrap/tailwind (lol)
*/

:root {
    --primaryColorUltraTransparent: rgba(81, 121, 240, 0.1);
    --primaryColorSuperTransparent: rgba(81, 121, 240, 0.2);
    --primaryColorTransparent: rgba(81, 121, 240, 0.5);
    --primaryColorFaded: rgba(81, 121, 240, 0.75);
    --primaryColorBright: rgb(81, 121, 240); /* hex = #5179f0 */
    --primaryColorGradient: linear-gradient(150deg,
      var(--primaryColorMediumFaded) 50%,
      var(--primaryColorDarkFaded) 50%);
  
    --primaryColorMediumTransparent: rgba(66, 111, 201, 0.5);
    --primaryColorMediumFaded: rgba(66, 111, 201, 0.75);
    --primaryColorMedium: rgb(66, 111, 201);
  
    --primaryColorDarkTransparent: rgba(52, 85, 150, 0.5);
    --primaryColorDarkFaded: rgba(52, 85, 150, 0.75);
    --primaryColorDark: rgb(52, 85, 150);
  
    --secondaryColorTransparent: rgba(176, 185, 186, 0.5);
    --secondaryColorFaded: rgba(176, 185, 186, 0.75);
    --secondaryColorBright: rgb(176, 185, 186);
    --secondaryColorDark: rgb(131, 142, 150);
    --secondaryColorGradient: linear-gradient(150deg,
      #fff2 50%
      #fff6 50%,);
  
    --dangerColorTransparent: rgba(236, 101, 101, 0.5);
    --dangerColorFaded: rgba(236, 101, 101, 0.75);
    --dangerColorBright: rgb(236, 101, 101);

    --dangerColorMediumTransparent: rgba(188, 60, 60, 0.5);
    --dangerColorMediumFaded: rgba(188, 60, 60, 0.75);
    --dangerColorMedium: rgb(188, 60, 60);

    --dangerColorDarkTransparent: rgba(156, 51, 51, 0.5);
    --dangerColorDarkFaded: rgba(156, 51, 51, 0.75);
    --dangerColorDark: rgb(156, 51, 51);

    --dangerColorGradient: linear-gradient(150deg,
        var(--dangerColorMediumFaded) 50%,
        var(--dangerColorDarkFaded) 50%);
  
    --footerColor: rgb(24, 30, 42);
    --footerColorDark: rgb(14, 19, 28);
  
    --linkColor: rgb(65, 149, 228);

    --loadingColor1: rgb(42, 255, 198);
    --loadingColor2: rgb(0, 204, 255);
  
    --menuBarHeight: min(60px, 20vh);
    --homepagePanelWidth: min(1800px, 100%);
    --exploreSideviewWidth: min(500px, 90%);
    --exploreSideviewheight: 100%;

    --_120px_6_padding: min(120px, 6%);
    --_120px_6_paddingHorizontal: min(120px, 6vw);
    --_120px_6_paddingVertical: min(120px, 6vh);

    --_60px_3_padding: min(60px, 3%);
    --_60px_3_paddingHorizontal: min(60px, 3vw);
    --_60px_3_paddingVertical: min(60px, 3vh);

    --scaled5px: min(5px, 0.5%);
    --scaled10px: min(10px, 1%);
    --scaled15px: min(15px, 1.5%);
    --scaled20px: min(20px, 2%);
    --scaled25px: min(25px, 2.5%);
    --scaled30px: min(30px, 3%);
    --scaled50px: min(50px, 5%);
    --scaled100px: min(100px, 10%);
    --scaled150px: min(150px, 15%);
    --scaled200px: min(200px, 20%);
  
    --crystalGradientMagenta: linear-gradient(150deg, #f0f6, #f1f4 50%, #f0f5 50%, #d0d9);
    --crystalGradientRed: linear-gradient(150deg, #f006, #f004 50%, #f005 50%, #f009);
    --crystalGradientOrange: linear-gradient(150deg, #f806, #f804 50%, #e705 50%, #e609);
    --crystalGradientYellow: linear-gradient(150deg, #ff06, #ff14 50%, #dc05 50%, #ba09);
    --crystalGradientLime: linear-gradient(150deg, #1f26, #0f14 50%, #0c05 50%, #0b09);
    --crystalGradientAqua: linear-gradient(150deg, #0bf6, #0be4 50%, #0ae5 50%, #09c9);
  
    --displayFont: "Red Hat Display", Mulish, Outfit, system-ui, sans-serif;
    --paragraphFont: Mulish, Outfit, Lexend, system-ui, sans-serif;
}
  
body {
    font-family: var(--paragraphFont);
    font-size: 20px;
}
  
.App {
    font-family: var(--paragraphFont);
    font-size: 20px;
}
  
.generic-page-body {
    margin-top: var(--menuBarHeight);
    height: calc(100vh - var(--menuBarHeight));
    position: relative;
}
.generic-page-body-expandable {
    margin-top: var(--menuBarHeight);
    min-height: calc(100vh - var(--menuBarHeight));
    position: relative;
    display: flex;
    flex-direction: column;
}
  
  
a {
    text-decoration: none;
    color: var(--linkColor);
    width: -moz-fit-content;
    width: fit-content;
}
a:hover {
    text-decoration: underline;
}

/* Flexbox */
.flex-row {
    display: flex;
    flex-direction: row;
}
.flex-column {
    display: flex;
    flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex-grow-1 {
    flex-grow: 1;
}
.align-center {
    align-items: center;
}
.align-start {
    align-items: flex-start;
}
.align-end {
    align-items: flex-end;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.justify-around {
    justify-content: space-around;
}
.justify-evenly {
    justify-content: space-evenly;
}

.flex-gap-2px {
    gap: 2px;
}
.flex-gap-5px {
    gap: 5px;
}
.flex-gap-10px {
    gap: 10px;
}
.flex-gap-15px {
    gap: 15px;
}
.flex-gap-20px {
    gap: 20px;
}
.flex-gap-50px {
    gap: 50px;
}

.row-gap-2px {
    row-gap: 2px;
}
.row-gap-5px {
    row-gap: 5px;
}
.row-gap-10px {
    row-gap: 10px;
}
.row-gap-15px {
    row-gap: 15px;
}
.row-gap-20px {
    row-gap: 20px;
}
.row-gap-50px {
    row-gap: 50px;
}

.column-gap-2px {
    column-gap: 2px;
}
.column-gap-5px {
    column-gap: 5px;
}
.column-gap-10px {
    column-gap: 10px;
}
.column-gap-15px {
    column-gap: 15px;
}
.column-gap-20px {
    column-gap: 20px;
}
.column-gap-50px {
    column-gap: 50px;
}


/* Borders */
.light-border-1px {
    border: 1px solid #00000020;
}
.light-border-2px {
    border: 2px solid #00000020;
}
.rounded-3px {
    border-radius: 3px;
}
.rounded-5px {
    border-radius: 5px;
}
.rounded-8px {
    border-radius: 8px;
}
.rounded-10px {
    border-radius: 10px;
}
.rounded-15px {
    border-radius: 15px;
}
.rounded-20px {
    border-radius: 20px;
}
.rounded-full {
    border-radius: 50%;
}

/* Overflow */
.overflow-hidden {
    overflow: hidden;
}
.overflow-visible {
    overflow: visible;
}
.overflow-scroll {
    overflow: scroll;
}
.overflow-auto {
    overflow: auto;
}

.overflow-x-hidden {
    overflow-x: hidden;
}
.overflow-x-visible {
    overflow-x: visible;
}
.overflow-x-scroll {
    overflow-x: scroll;
}
.overflow-x-auto {
    overflow-x: auto;
}

.overflow-y-hidden {
    overflow-y: hidden;
}
.overflow-y-visible {
    overflow-y: visible;
}
.overflow-y-scroll {
    overflow-y: scroll;
}
.overflow-y-auto {
    overflow-y: auto;
}

/* Padding */

.padding-0px {
    padding: 0px;
}
.padding-5px {
    padding: 5px;
}
.padding-10px {
    padding: 10px;
}
.padding-15px {
    padding: 15px;
}
.padding-20px {
    padding: 20px;
}
.padding-50px {
    padding: 50px;
}
.padding-x-0px {
    padding-left: 0px;
    padding-right: 0px;
}
.padding-x-5px {
    padding-left: 5px;
    padding-right: 5px;
}
.padding-x-10px {
    padding-left: 10px;
    padding-right: 10px;
}
.padding-x-15px {
    padding-left: 15px;
    padding-right: 15px;
}
.padding-x-20px {
    padding-left: 20px;
    padding-right: 20px;
}
.padding-x-50px {
    padding-left: 50px;
    padding-right: 50px;
}

.padding-y-0px {
    padding-top: 0px;
    padding-bottom: 0px;
}
.padding-y-5px {
    padding-top: 5px;
    padding-bottom: 5px;
}
.padding-y-10px {
    padding-top: 10px;
    padding-bottom: 10px;
}
.padding-y-15px {
    padding-top: 15px;
    padding-bottom: 15px;
}
.padding-y-20px {
    padding-top: 20px;
    padding-bottom: 20px;
}
.padding-y-50px {
    padding-top: 50px;
    padding-bottom: 50px;
}

.padding-top-0px {
    padding-top: 0px;
}
.padding-top-5px {
    padding-top: 5px;
}
.padding-top-10px {
    padding-top: 10px;
}
.padding-top-15px {
    padding-top: 15px;
}
.padding-top-20px {
    padding-top: 20px;
}
.padding-top-50px {
    padding-top: 50px;
}

.padding-bottom-0px {
    padding-bottom: 0px;
}
.padding-bottom-5px {
    padding-bottom: 5px;
}
.padding-bottom-10px {
    padding-bottom: 10px;
}
.padding-bottom-15px {
    padding-bottom: 15px;
}
.padding-bottom-20px {
    padding-bottom: 20px;
}
.padding-bottom-25px {
    padding-bottom: 25px;
}
.padding-bottom-30px {
    padding-bottom: 30px;
}
.padding-bottom-50px {
    padding-bottom: 50px;
}

.padding-left-0px {
    padding-left: 0px;
}
.padding-left-5px {
    padding-left: 5px;
}
.padding-left-10px {
    padding-left: 10px;
}
.padding-left-15px {
    padding-left: 15px;
}
.padding-left-20px {
    padding-left: 20px;
}
.padding-left-50px {
    padding-left: 50px;
}

.padding-right-0px {
    padding-right: 0px;
}
.padding-right-5px {
    padding-right: 5px;
}
.padding-right-10px {
    padding-right: 10px;
}
.padding-right-15px {
    padding-right: 15px;
}
.padding-right-20px {
    padding-right: 20px;
}
.padding-right-50px {
    padding-right: 50px;
}

/* Margin */

.margin-0px {
    margin: 0px;
}
.margin-5px {
    margin: 5px;
}
.margin-10px {
    margin: 10px;
}
.margin-15px {
    margin: 15px;
}
.margin-20px {
    margin: 20px;
}
.margin-50px {
    margin: 50px;
}

.margin-top-0px {
    margin-top: 0px;
}
.margin-top-5px {
    margin-top: 5px;
}
.margin-top-10px {
    margin-top: 10px;
}
.margin-top-15px {
    margin-top: 15px;
}
.margin-top-20px {
    margin-top: 20px;
}
.margin-top-50px {
    margin-top: 50px;
}

.margin-bottom-0px {
    margin-bottom: 0px;
}
.margin-bottom-5px {
    margin-bottom: 5px;
}
.margin-bottom-10px {
    margin-bottom: 10px;
}
.margin-bottom-15px {
    margin-bottom: 15px;
}
.margin-bottom-20px {
    margin-bottom: 20px;
}
.margin-bottom-50px {
    margin-bottom: 50px;
}

.margin-left-0px {
    margin-left: 0px;
}
.margin-left-5px {
    margin-left: 5px;
}
.margin-left-10px {
    margin-left: 10px;
}
.margin-left-15px {
    margin-left: 15px;
}
.margin-left-20px {
    margin-left: 20px;
}
.margin-left-50px {
    margin-left: 50px;
}

.margin-right-0px {
    margin-right: 0px;
}
.margin-right-5px {
    margin-right: 5px;
}
.margin-right-10px {
    margin-right: 10px;
}
.margin-right-15px {
    margin-right: 15px;
}
.margin-right-20px {
    margin-right: 20px;
}
.margin-right-50px {
    margin-right: 50px;
}

.margin-auto {
    margin: auto;
}
.margin-x-auto {
    margin-left: auto;
    margin-right: auto;
}
.margin-y-auto {
    margin-top: auto;
    margin-bottom: auto;
}
.margin-top-auto {
    margin-top: auto;
}
.margin-bottom-auto {
    margin-bottom: auto;
}
.margin-left-auto {
    margin-left: auto;
}
.margin-right-auto {
    margin-right: auto;
}

/* Text */
.text-center {
    text-align: center;
}
.text-left {
    text-align: left;
}
.text-right {
    text-align: right;
}

.text-decoration-italic {
    -webkit-text-decoration: italic;
            text-decoration: italic;
}
.text-decoration-underline {
    text-decoration: underline;
}
.text-decoration-none {
    text-decoration: none;
}
.hover-text-decoration-underline:hover {
    text-decoration: underline !important;
}
.hover-text-decoration-none:hover {
    text-decoration: none !important;
}

.text-black {
    color: #000000;
}
.text-white {
    color: #ffffff;
}
.text-danger {
    color: var(--dangerColorBright);
}

.line-height-0px {
    line-height: 0px;
}
.line-height-5px {
    line-height: 5px;
}
.line-height-1 {
    line-height: 1;
}

.font-size-8px {
    font-size: 8px !important;
}
.font-size-10px {
    font-size: 10px !important;
}
.font-size-12px {
    font-size: 12px !important;
}
.font-size-14px {
    font-size: 14px !important;
}
.font-size-16px {
    font-size: 16px !important;
}
.font-size-18px {
    font-size: 18px !important;
}
.font-size-20px {
    font-size: 20px !important;
}
.font-size-24px {
    font-size: 24px !important;
}
.font-size-28px {
    font-size: 28px !important;
}
.font-size-30px {
    font-size: 30px !important;
}
.font-size-36px {
    font-size: 36px !important;
}
.font-size-40px {
    font-size: 40px !important;
}
.font-size-50px {
    font-size: 50px !important;
}
.font-size-60px {
    font-size: 60px !important;
}
.font-size-70px {
    font-size: 70px !important;
}
.font-size-80px {
    font-size: 80px !important;
}
.font-size-90px {
    font-size: 90px !important;
}
.font-size-100px {
    font-size: 100px !important;
}
.font-size-120px {
    font-size: 120px !important;
}
.font-size-150px {
    font-size: 150px !important;
}
.font-weight-300 {
    font-weight: 400 !important;
}
.font-weight-400 {
    font-weight: 400 !important;
}
.font-weight-500 {
    font-weight: 500 !important;
}
.font-weight-600 {
    font-weight: 600 !important;
}
.font-weight-700 {
    font-weight: 700 !important;
}
.font-weight-800 {
    font-weight: 800 !important;
}
.font-weight-900 {
    font-weight: 900 !important;
}
.font-weight-1000 {
    font-weight: 1000 !important;
}

.text-nowrap {
    white-space: nowrap;
}
.text-wrap {
    white-space: normal;
}

.text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.font-display {
    font-family: "Red Hat Display", Outfit, Mulish;
}

/* Z-index */
.z-index--3 {
    z-index: -3;
}
.z-index--2 {
    z-index: -2;
}
.z-index--1 {
    z-index: -1;
}
.z-index-0 {
    z-index: 0;
}
.z-index-1 {
    z-index: 1;
}
.z-index-2 {
    z-index: 2;
}
.z-index-3 {
    z-index: 3;
}
.z-index-4 {
    z-index: 4;
}
.z-index-5 {
    z-index: 5;
}
.z-index-10 {
    z-index: 10;
}
.z-index-20 {
    z-index: 20;
}
.z-index-50 {
    z-index: 50;
}
.z-index-100 {
    z-index: 100;
}

/* Size */
.width-fit-content {
    width: -moz-fit-content;
    width: fit-content;
}
.width-max-content {
    width: max-content;
}
.width-min-content {
    width: min-content;
}

.height-fit-content {
    height: -moz-fit-content;
    height: fit-content;
}
.height-max-content {
    height: max-content;
}
.height-min-content {
    height: min-content;
}

.min-width-max-content {
    min-width: max-content;
}
.min-width-min-content {
    min-width: min-content;
}

.max-width-max-content {
    max-width: max-content;
}
.max-width-min-content {
    max-width: min-content;
}

.width-100 {
    width: 100% !important;
}
.width-50 {
    width: 50%;
}
.width-25 {
    width: 25%;
}

.height-100 {
    height: 100%;
}
.height-50 {
    height: 50%;
}
.height-25 {
    height: 25%;
}

.max-width-100 {
    max-width: 100%;
}
.max-width-50 {
    max-width: 50%;
}
.max-width-25 {
    max-width: 25%;
}

.max-width-50px {
    max-width: 50px;
}
.max-width-100px {
    max-width: 100px;
}
.max-width-150px {
    max-width: 150px;
}
.max-width-200px {
    max-width: 200px;
}
.max-width-300px {
    max-width: 300px;
}
.max-width-400px {
    max-width: 400px;
}
.max-width-500px {
    max-width: 500px;
}


.max-height-100 {
    max-height: 100%;
}
.max-height-50 {
    max-height: 50%;
}
.max-height-25 {
    max-height: 25%;
}

.max-height-50px {
    max-height: 50px;
}
.max-height-100px {
    max-height: 100px;
}
.max-height-150px {
    max-height: 150px;
}
.max-height-200px {
    max-height: 200px;
}
.max-height-300px {
    max-height: 300px;
}
.max-height-400px {
    max-height: 400px;
}
.max-height-500px {
    max-height: 500px;
}

.min-width-100 {
    min-width: 100%;
}
.min-width-50 {
    min-width: 50%;
}
.min-width-25 {
    min-width: 25%;
}

.min-width-50px {
    min-width: 50px;
}
.min-width-100px {
    min-width: 100px;
}
.min-width-150px {
    min-width: 150px;
}
.min-width-200px {
    min-width: 200px;
}
.min-width-300px {
    min-width: 300px;
}
.min-width-400px {
    min-width: 400px;
}
.min-width-500px {
    min-width: 500px;
}


.min-height-100 {
    min-height: 100%;
}
.min-height-50 {
    min-height: 50%;
}
.min-height-25 {
    min-height: 25%;
}

.min-height-50px {
    min-height: 50px;
}
.min-height-100px {
    min-height: 100px;
}
.min-height-150px {
    min-height: 150px;
}
.min-height-200px {
    min-height: 200px;
}
.min-height-300px {
    min-height: 300px;
}
.min-height-400px {
    min-height: 400px;
}
.min-height-500px {
    min-height: 500px;
}

.height-inherit {
    height: inherit;
}
.width-inherit {
    width: inherit;
}
.height-auto {
    height: auto;
}
.width-auto {
    width: auto;
}
.height-100vh {
    height: 100vh;
}
.width-100vw {
    width: 100vw;
}

.border-box {
    box-sizing: border-box;
}
.content-box {
    box-sizing: content-box;
}

/* Custom components */

.select-primary {
    font-size: 16px;
    box-sizing: border-box;
    outline: none;
    caret-color: rgba(20, 22, 22, 0.564);
    border:none;
    border-bottom: 2px solid rgba(0, 0, 0, 0.348);
    padding: 5px 10px;
    margin:0;
    font-family: var(--paragraphFont);
    background-color: transparent;
    cursor: pointer;
}

.input-primary {
    width: 100%;
    font-size: 16px;
    box-sizing: border-box;
    outline: none;
    border:none;
    border-bottom: 2px solid #0005;
    background-color: transparent;
    padding: 5px 10px;
    transition: 0.2s;
    font-family: var(--paragraphFont);
}
.input-primary:focus-visible {
    border-bottom: 2px solid var(--primaryColorBright);
    background-image: linear-gradient(0deg, var(--primaryColorUltraTransparent) 10%, #fff0 20%);
}

.textarea-primary {
    width: 100%;
    height: 100px;
    font-size: 16px;
    font-weight: 400;
    border-radius: 7px;
    outline: none;
    box-sizing: border-box;
    padding: 5px 10px;
    font-family: var(--paragraphFont);
    resize:vertical;
    min-height: 3em;
    transition: border, box-shadow 0.2s;
    border: 2px solid #0005;
}
.textarea-primary:focus-visible {
    border: 2px solid var(--primaryColorBright);
    box-shadow: 0 0 1px 3px var(--primaryColorSuperTransparent);
}

.info-message {
    border: 2px solid var(--secondaryColorBright);
    color: var(--secondaryColorBright);
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
}
.error-message {
    border: 2px solid var(--dangerColorBright);
    color: var(--dangerColorBright);
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
}
.success-message {
    border: 2px solid rgb(0, 188, 0);
    color: rgb(0, 180, 0);
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
}

.button-primary, .button-secondary, .button-danger, .button-secondary-dark {
    border-radius: 1000px;
    font-weight: 600;
    font-family: var(--displayFont);
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.2s;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/* All disabled button-primary */
.button-primary[disabled] {
    border-radius: 1000px;
    font-weight: 500;
    font-family: var(--displayFont);
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.1s;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: white;
    opacity: 0.6;
    box-shadow: none;
    cursor: wait;
    pointer-events: none;
}
.button-danger[disabled] {
    border-radius: 1000px;
    font-weight: 500;
    font-family: var(--displayFont);
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.1s;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: transparent;
    color: white;
    box-shadow: none;
    cursor: wait;
    pointer-events: none;
}
.button-secondary[disabled] {
    border-radius: 1000px;
    font-weight: 500;
    font-family: var(--displayFont);
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.1s;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #00000020;
    color: #0007;
    background-color: transparent;
    box-shadow: none;
    cursor: wait;
    pointer-events: none;
}
.button-secondary-dark[disabled] {
    border-radius: 1000px;
    font-weight: 500;
    font-family: var(--displayFont);
    border: none;
    outline: none;
    cursor: pointer;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #00000020;
    color: #fff6;
    background-color: transparent;
    box-shadow: none;
    cursor: default;
    pointer-events: none;
}

.button-danger {
    color: white;
    background-color: var(--dangerColorBright);
    background-image: var(--dangerColorGradient);
    box-shadow: 0px 1px 2px 0px #00000030;
}
.button-danger:hover {
    background-color: var(--dangerColorDark);
    box-shadow: -1px 2px 3px 1px #00000030;
}

.button-primary {
    color: white;
    background-color: var(--primaryColorBright);
    background-image: linear-gradient(150deg,
        var(--primaryColorMediumFaded) 50%,
        var(--primaryColorDarkFaded) 50%);
    box-shadow: 0px 1px 4px 1px #00000030;
}
.button-primary:hover {
    background-color: black;
    box-shadow: 0px 2px 5px 1px #00000040;
}

.button-secondary {
    background-color: transparent;
    background-image: linear-gradient(150deg,
        #fff2 50%,
        #7772 50%);
    border: 1px solid #00000020;
    box-shadow: 0px 1px 4px 1px #00000020;
}
.button-secondary:hover {
    background-color: #2242;
    box-shadow: 0px 2px 5px 1px #00000030;
}
.button-secondary-dark {
    background-color: transparent;
    background-image: linear-gradient(150deg,
        #fff3 50%,
        #fff2 50%);
    color: #fff;
    border: none;
    box-shadow: 0px 1px 4px 1px #00000020;
}
.button-secondary-dark:hover {
    background-color: #fff2;
    box-shadow: 0px 2px 5px 1px #00000030;
}

.button-mopo {
    margin: 0;
    padding: 0;
}
.button-small {
    padding: 3px 10px;
    font-size: 0.6em;
    box-sizing: border-box;
}
.button-medium {
    padding: 5px 22px;
    font-size: 0.75em;
    box-sizing: border-box;
}
.button-large {
    padding: 8px 27px;
    font-size: 0.9em;
    box-sizing: border-box;
}

.minilabel {
    width: -moz-fit-content;
    width: fit-content;
    font-size: 14px;
    font-weight: 500;
    font-family: var(--paragraphFont);
    margin-bottom: 5px;
}

.hover-underline-1px, .hover-underline-2px {
    position: relative;
}
.hover-underline-1px::before, .hover-underline-2px::before {
    content: '';
    position: absolute;
    width: 0;
    top: 100%;
    left: 50%;
    color: inherit;
    background-color: currentColor;
    transition: 0.2s cubic-bezier( 0.07, 0.52, 0.08, 0.9 );
}
.hover-underline-1px::before {
    height: 1px;
}
.hover-underline-2px::before {
    height: 2px;
}
.hover-underline-1px:hover::before, .hover-underline-2px:hover::before {
    width: 100%;
    left: 0;
}
.hover-underline-selected::before {
    width: 100% !important;
    left: 0;
}

.link {
    text-decoration: none;
    color: var(--linkColor);
    width: -moz-fit-content;
    width: fit-content;
}
.link:hover {
    text-decoration: underline;
}
.link-invis {
    text-decoration: none;
    color: inherit;
    width: -moz-fit-content;
    width: fit-content;
    padding: 0;
    margin: 0;
}
.img-link-invis {
    display: block;
    font-size: 0;
    text-decoration: none;
    color: inherit;
    width: -moz-fit-content;
    width: fit-content;
}

/* File input that fills the entire button, but is invisible */
.file-input-invis {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity:0;
    cursor: pointer;
}

.centerer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.center-children {
    display: flex;
    justify-content: center;
    align-items: center;
}

.mopo {
    margin: 0;
    padding: 0;
}

@keyframes flyin-top {
    0% {
        transform: translateY(-50%);
        opacity: 0.5;
    }
    100% {
        transform: translateY(0%);
        opacity: 1;
    }
}
.flyin-top {
    animation: flyin-top 0.2s ease-in-out;
}

/* Testing */
.red {
    background-color: rgba(255, 0, 0, 0.301);
}
.green {
    background-color: rgba(0, 212, 0, 0.307);
}
.blue {
    background-color: rgba(0, 0, 255, 0.303);
}
.yellow {
    background-color: rgba(211, 211, 0, 0.33);
}
.purple {
    background-color: rgba(174, 0, 197, 0.3);
}
.orange {
    background-color: rgba(255, 153, 0, 0.4);
}
.pink {
    background-color: rgba(255, 103, 159, 0.272);
}
.cyan {
    background-color: rgba(0, 203, 193, 0.335);
}
.aqua {
    background-color: rgba(61, 187, 255, 0.248);
}

/* Positioning */
.position-relative {
    position: relative;
}
.position-absolute {
    position: absolute;
}
.position-fixed {
    position: fixed;
}
.position-static {
    position: static;
}
.position-sticky {
    position: sticky;
}

.float-left {
    float: left;
}
.float-right {
    float: right;
}
.float-none {
    float: none;
}

.align-self-start {
    align-self: flex-start;
}
.align-self-center {
    align-self: center;
}
.align-self-end {
    align-self: flex-end;
}

.left-0 {
    left: 0;
}
.left-50 {
    left: 50%;
}
.left-100 {
    left: 100%;
}

.right-0 {
    right: 0;
}
.right-50 {
    right: 50%;
}
.right-100 {
    right: 100%;
}

.top-0 {
    top: 0;
}
.top-50 {
    top: 50%;
}
.top-100 {
    top: 100%;
}

/* Display */
.display-none {
    display: none;
}
.display-block {
    display: block;
}
.display-inline {
    display: inline;
}
.display-inline-block {
    display: inline-block;
}
.display-flex {
    display: flex;
}
.display-inline-flex {
    display: inline-flex;
}

/* Shadows */
.shadow-light {
    box-shadow: 0px 1px 2px 0px #00000030;
}
.shadow-light-2 {
    box-shadow: -1px 2px 3px 1px #00000030;
}

.shadow-medium {
    box-shadow: 0px 1px 3px 0px #00000040;
}
.shadow-medium-2 {
    box-shadow: -1px 2px 5px 1px #00000040;
}

.shadow-dark {
    box-shadow: -1px 2px 5px 1px #00000050;
}
.shadow-dark-2 {
    box-shadow: -1px 2px 7px 1px #00000050;
}

/* Quick Images */
.image-10px {
    width: 10px;
    height: 10px;
}
.image-15px {
    width: 15px;
    height: 15px;
}
.image-20px {
    width: 20px;
    height: 20px;
}
.image-25px {
    width: 25px;
    height: 25px;
}
.image-30px {
    width: 30px;
    height: 30px;
}
.image-40px {
    width: 40px;
    height: 40px;
}
.image-50px {
    width: 50px;
    height: 50px;
}
.image-75px {
    width: 75px;
    height: 75px;
}
.image-100px {
    width: 100px;
    height: 100px;
}
.image-150px {
    width: 150px;
    height: 150px;
}
.image-200px {
    width: 200px;
    height: 200px;
}
.image-300px {
    width: 300px;
    height: 300px;
}
.image-400px {
    width: 400px;
    height: 400px;
}
.invert-100 {
    filter: invert(100%);
}

/* Transition */
.transition-0-1s {
    transition: 0.1s;
}
.transition-0-2s {
    transition: 0.2s;
}
.transition-0-3s {
    transition: 0.3s;
}
.transition-0-4s {
    transition: 0.4s;
}
.transition-0-5s {
    transition: 0.5s;
}
.transition-0-6s {
    transition: 0.6s;
}
.transition-0-7s {
    transition: 0.7s;
}
.transition-0-8s {
    transition: 0.8s;
}
.transition-0-9s {
    transition: 0.9s;
}
.transition-1s {
    transition: 1s;
}
.transition-2s {
    transition: 2s;
}
.transition-ease {
    transition-timing-function: ease;
}
.transition-ease-in {
    transition-timing-function: ease-in;
}
.transition-ease-out {
    transition-timing-function: ease-out;
}
.transition-ease-in-out {
    transition-timing-function: ease-in-out;
}
.transition-linear {
    transition-timing-function: linear;
}

/* Hover styles */
.cursor-pointer {
    cursor: pointer;
}
.cursor-default {
    cursor: default;
}
.cursor-text {
    cursor: text;
}
.cursor-wait {
    cursor: wait;
}
.cursor-move {
    cursor: move;
}
.cursor-yresize {
    cursor: ns-resize;
}
.cursor-xresize {
    cursor: ew-resize;
}
.hover-scale-1-01:hover {
    transform: scale(1.01);
}
.hover-scale-1-02:hover {
    transform: scale(1.02);
}
.hover-scale-1-03:hover {
    transform: scale(1.03);
}
.hover-scale-1-04:hover {
    transform: scale(1.04);
}
.hover-scale-1-05:hover {
    transform: scale(1.05);
}
.hover-scale-1-1:hover {
    transform: scale(1.1);
}

.hover-light-shadow:hover {
    box-shadow: 0px 1px 2px 0px #00000030;
}
.hover-light-shadow-2:hover {
    box-shadow: -1px 2px 3px 1px #00000030;
}
.hover-medium-shadow:hover {
    box-shadow: 0px 1px 3px 1px #00000040;
}
.hover-medium-shadow-2:hover {
    box-shadow: -1px 2px 5px 1px #00000040;
}
.hover-dark-shadow:hover {
    box-shadow: -1px 2px 5px 1px #00000050;
}
.hover-dark-shadow-2:hover {
    box-shadow: -1px 2px 7px 1px #00000050;
}

/* Color */

.text-ultra-light {
    color: #00000040;
}
.text-light {
    color: #00000080;
}
.text-faded {
    color: #000000c0;
}
.text-dark {
    color: #000000;
}

.background-transparent {
    background-color: transparent;
}
.background-white {
    background-color: white;
}
.background-black {
    background-color: black;
}

/* Filters */
.filter-none {
    filter: none;
}
.filter-grayscale {
    filter: grayscale(100%);
}
.filter-invert {
    filter: invert(100%);
}
.filter-opacity-100 {
    opacity: 1;
}
.filter-opacity-75 {
    opacity: 0.75;
}
.filter-opacity-50 {
    opacity: 0.5;
}
.filter-opacity-25 {
    opacity: 0.25;
}
.filter-opacity-0 {
    opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/general/prebuilt.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;IACI,uDAAuD;IACvD,uDAAuD;IACvD,kDAAkD;IAClD,6CAA6C;IAC7C,uCAAuC,EAAE,kBAAkB;IAC3D;;uCAEmC;;IAEnC,wDAAwD;IACxD,mDAAmD;IACnD,uCAAuC;;IAEvC,qDAAqD;IACrD,gDAAgD;IAChD,oCAAoC;;IAEpC,qDAAqD;IACrD,gDAAgD;IAChD,0CAA0C;IAC1C,wCAAwC;IACxC;;iBAEa;;IAEb,kDAAkD;IAClD,6CAA6C;IAC7C,uCAAuC;;IAEvC,sDAAsD;IACtD,iDAAiD;IACjD,qCAAqC;;IAErC,oDAAoD;IACpD,+CAA+C;IAC/C,mCAAmC;;IAEnC;;wCAEoC;;IAEpC,8BAA8B;IAC9B,kCAAkC;;IAElC,8BAA8B;;IAE9B,kCAAkC;IAClC,iCAAiC;;IAEjC,gCAAgC;IAChC,uCAAuC;IACvC,uCAAuC;IACvC,6BAA6B;;IAE7B,kCAAkC;IAClC,6CAA6C;IAC7C,2CAA2C;;IAE3C,gCAAgC;IAChC,2CAA2C;IAC3C,yCAAyC;;IAEzC,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;;IAE9B,qFAAqF;IACrF,iFAAiF;IACjF,oFAAoF;IACpF,oFAAoF;IACpF,kFAAkF;IAClF,kFAAkF;;IAElF,uEAAuE;IACvE,8DAA8D;AAClE;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,8CAA8C;IAC9C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,QAAQ;AACZ;AACA;IACI,QAAQ;AACZ;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;;AAGA,YAAY;AACZ;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA,YAAY;;AAEZ;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA,WAAW;;AAEX;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAAuB;YAAvB,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;AAClD;;AAEA,YAAY;AACZ;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA,SAAS;AACT;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAmB;IAAnB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;;AAEA,sBAAsB;;AAEtB;IACI,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,6CAA6C;IAC7C,iBAAiB;IACjB,QAAQ;IACR,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;AACrC;AACA;IACI,kDAAkD;IAClD,2FAA2F;AAC/F;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,mCAAmC;IACnC,uBAAuB;AAC3B;AACA;IACI,2CAA2C;IAC3C,2DAA2D;AAC/D;;AAEA;IACI,6CAA6C;IAC7C,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,0CAA0C;IAC1C,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0CAA0C;IAC1C,4CAA4C;IAC5C,qCAAqC;AACzC;AACA;IACI,wCAAwC;IACxC,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C;;yCAEqC;IACrC,qCAAqC;AACzC;AACA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B;;kBAEc;IACd,2BAA2B;IAC3B,qCAAqC;AACzC;AACA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,6BAA6B;IAC7B;;kBAEc;IACd,WAAW;IACX,YAAY;IACZ,qCAAqC;AACzC;AACA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,SAAS;IACT,cAAc;IACd,8BAA8B;IAC9B,sDAAsD;AAC1D;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,OAAO;AACX;AACA;IACI,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QACI,2BAA2B;QAC3B,YAAY;IAChB;IACA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;AACA;IACI,qCAAqC;AACzC;;AAEA,YAAY;AACZ;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,4CAA4C;AAChD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,2CAA2C;AAC/C;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,OAAO;AACX;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;AACd;;AAEA;IACI,QAAQ;AACZ;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;;AAEA;IACI,MAAM;AACV;AACA;IACI,QAAQ;AACZ;AACA;IACI,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;;AAEA,YAAY;AACZ;IACI,qCAAqC;AACzC;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;AAEA,UAAU;;AAEV;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;;AAEA,YAAY;AACZ;IACI,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;AACd","sourcesContent":["/* \nPrebuilt styles for quick use\nBasically bootleg bootstrap/tailwind (lol)\n*/\n\n:root {\n    --primaryColorUltraTransparent: rgba(81, 121, 240, 0.1);\n    --primaryColorSuperTransparent: rgba(81, 121, 240, 0.2);\n    --primaryColorTransparent: rgba(81, 121, 240, 0.5);\n    --primaryColorFaded: rgba(81, 121, 240, 0.75);\n    --primaryColorBright: rgb(81, 121, 240); /* hex = #5179f0 */\n    --primaryColorGradient: linear-gradient(150deg,\n      var(--primaryColorMediumFaded) 50%,\n      var(--primaryColorDarkFaded) 50%);\n  \n    --primaryColorMediumTransparent: rgba(66, 111, 201, 0.5);\n    --primaryColorMediumFaded: rgba(66, 111, 201, 0.75);\n    --primaryColorMedium: rgb(66, 111, 201);\n  \n    --primaryColorDarkTransparent: rgba(52, 85, 150, 0.5);\n    --primaryColorDarkFaded: rgba(52, 85, 150, 0.75);\n    --primaryColorDark: rgb(52, 85, 150);\n  \n    --secondaryColorTransparent: rgba(176, 185, 186, 0.5);\n    --secondaryColorFaded: rgba(176, 185, 186, 0.75);\n    --secondaryColorBright: rgb(176, 185, 186);\n    --secondaryColorDark: rgb(131, 142, 150);\n    --secondaryColorGradient: linear-gradient(150deg,\n      #fff2 50%\n      #fff6 50%,);\n  \n    --dangerColorTransparent: rgba(236, 101, 101, 0.5);\n    --dangerColorFaded: rgba(236, 101, 101, 0.75);\n    --dangerColorBright: rgb(236, 101, 101);\n\n    --dangerColorMediumTransparent: rgba(188, 60, 60, 0.5);\n    --dangerColorMediumFaded: rgba(188, 60, 60, 0.75);\n    --dangerColorMedium: rgb(188, 60, 60);\n\n    --dangerColorDarkTransparent: rgba(156, 51, 51, 0.5);\n    --dangerColorDarkFaded: rgba(156, 51, 51, 0.75);\n    --dangerColorDark: rgb(156, 51, 51);\n\n    --dangerColorGradient: linear-gradient(150deg,\n        var(--dangerColorMediumFaded) 50%,\n        var(--dangerColorDarkFaded) 50%);\n  \n    --footerColor: rgb(24, 30, 42);\n    --footerColorDark: rgb(14, 19, 28);\n  \n    --linkColor: rgb(65, 149, 228);\n\n    --loadingColor1: rgb(42, 255, 198);\n    --loadingColor2: rgb(0, 204, 255);\n  \n    --menuBarHeight: min(60px, 20vh);\n    --homepagePanelWidth: min(1800px, 100%);\n    --exploreSideviewWidth: min(500px, 90%);\n    --exploreSideviewheight: 100%;\n\n    --_120px_6_padding: min(120px, 6%);\n    --_120px_6_paddingHorizontal: min(120px, 6vw);\n    --_120px_6_paddingVertical: min(120px, 6vh);\n\n    --_60px_3_padding: min(60px, 3%);\n    --_60px_3_paddingHorizontal: min(60px, 3vw);\n    --_60px_3_paddingVertical: min(60px, 3vh);\n\n    --scaled5px: min(5px, 0.5%);\n    --scaled10px: min(10px, 1%);\n    --scaled15px: min(15px, 1.5%);\n    --scaled20px: min(20px, 2%);\n    --scaled25px: min(25px, 2.5%);\n    --scaled30px: min(30px, 3%);\n    --scaled50px: min(50px, 5%);\n    --scaled100px: min(100px, 10%);\n    --scaled150px: min(150px, 15%);\n    --scaled200px: min(200px, 20%);\n  \n    --crystalGradientMagenta: linear-gradient(150deg, #f0f6, #f1f4 50%, #f0f5 50%, #d0d9);\n    --crystalGradientRed: linear-gradient(150deg, #f006, #f004 50%, #f005 50%, #f009);\n    --crystalGradientOrange: linear-gradient(150deg, #f806, #f804 50%, #e705 50%, #e609);\n    --crystalGradientYellow: linear-gradient(150deg, #ff06, #ff14 50%, #dc05 50%, #ba09);\n    --crystalGradientLime: linear-gradient(150deg, #1f26, #0f14 50%, #0c05 50%, #0b09);\n    --crystalGradientAqua: linear-gradient(150deg, #0bf6, #0be4 50%, #0ae5 50%, #09c9);\n  \n    --displayFont: \"Red Hat Display\", Mulish, Outfit, system-ui, sans-serif;\n    --paragraphFont: Mulish, Outfit, Lexend, system-ui, sans-serif;\n}\n  \nbody {\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n}\n  \n.App {\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n}\n  \n.generic-page-body {\n    margin-top: var(--menuBarHeight);\n    height: calc(100vh - var(--menuBarHeight));\n    position: relative;\n}\n.generic-page-body-expandable {\n    margin-top: var(--menuBarHeight);\n    min-height: calc(100vh - var(--menuBarHeight));\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n  \n  \na {\n    text-decoration: none;\n    color: var(--linkColor);\n    width: fit-content;\n}\na:hover {\n    text-decoration: underline;\n}\n\n/* Flexbox */\n.flex-row {\n    display: flex;\n    flex-direction: row;\n}\n.flex-column {\n    display: flex;\n    flex-direction: column;\n}\n.flex-wrap {\n    flex-wrap: wrap;\n}\n.flex-grow-1 {\n    flex-grow: 1;\n}\n.align-center {\n    align-items: center;\n}\n.align-start {\n    align-items: flex-start;\n}\n.align-end {\n    align-items: flex-end;\n}\n.justify-center {\n    justify-content: center;\n}\n.justify-between {\n    justify-content: space-between;\n}\n.justify-around {\n    justify-content: space-around;\n}\n.justify-evenly {\n    justify-content: space-evenly;\n}\n\n.flex-gap-2px {\n    gap: 2px;\n}\n.flex-gap-5px {\n    gap: 5px;\n}\n.flex-gap-10px {\n    gap: 10px;\n}\n.flex-gap-15px {\n    gap: 15px;\n}\n.flex-gap-20px {\n    gap: 20px;\n}\n.flex-gap-50px {\n    gap: 50px;\n}\n\n.row-gap-2px {\n    row-gap: 2px;\n}\n.row-gap-5px {\n    row-gap: 5px;\n}\n.row-gap-10px {\n    row-gap: 10px;\n}\n.row-gap-15px {\n    row-gap: 15px;\n}\n.row-gap-20px {\n    row-gap: 20px;\n}\n.row-gap-50px {\n    row-gap: 50px;\n}\n\n.column-gap-2px {\n    column-gap: 2px;\n}\n.column-gap-5px {\n    column-gap: 5px;\n}\n.column-gap-10px {\n    column-gap: 10px;\n}\n.column-gap-15px {\n    column-gap: 15px;\n}\n.column-gap-20px {\n    column-gap: 20px;\n}\n.column-gap-50px {\n    column-gap: 50px;\n}\n\n\n/* Borders */\n.light-border-1px {\n    border: 1px solid #00000020;\n}\n.light-border-2px {\n    border: 2px solid #00000020;\n}\n.rounded-3px {\n    border-radius: 3px;\n}\n.rounded-5px {\n    border-radius: 5px;\n}\n.rounded-8px {\n    border-radius: 8px;\n}\n.rounded-10px {\n    border-radius: 10px;\n}\n.rounded-15px {\n    border-radius: 15px;\n}\n.rounded-20px {\n    border-radius: 20px;\n}\n.rounded-full {\n    border-radius: 50%;\n}\n\n/* Overflow */\n.overflow-hidden {\n    overflow: hidden;\n}\n.overflow-visible {\n    overflow: visible;\n}\n.overflow-scroll {\n    overflow: scroll;\n}\n.overflow-auto {\n    overflow: auto;\n}\n\n.overflow-x-hidden {\n    overflow-x: hidden;\n}\n.overflow-x-visible {\n    overflow-x: visible;\n}\n.overflow-x-scroll {\n    overflow-x: scroll;\n}\n.overflow-x-auto {\n    overflow-x: auto;\n}\n\n.overflow-y-hidden {\n    overflow-y: hidden;\n}\n.overflow-y-visible {\n    overflow-y: visible;\n}\n.overflow-y-scroll {\n    overflow-y: scroll;\n}\n.overflow-y-auto {\n    overflow-y: auto;\n}\n\n/* Padding */\n\n.padding-0px {\n    padding: 0px;\n}\n.padding-5px {\n    padding: 5px;\n}\n.padding-10px {\n    padding: 10px;\n}\n.padding-15px {\n    padding: 15px;\n}\n.padding-20px {\n    padding: 20px;\n}\n.padding-50px {\n    padding: 50px;\n}\n.padding-x-0px {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n.padding-x-5px {\n    padding-left: 5px;\n    padding-right: 5px;\n}\n.padding-x-10px {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n.padding-x-15px {\n    padding-left: 15px;\n    padding-right: 15px;\n}\n.padding-x-20px {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.padding-x-50px {\n    padding-left: 50px;\n    padding-right: 50px;\n}\n\n.padding-y-0px {\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n.padding-y-5px {\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n.padding-y-10px {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.padding-y-15px {\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n.padding-y-20px {\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n.padding-y-50px {\n    padding-top: 50px;\n    padding-bottom: 50px;\n}\n\n.padding-top-0px {\n    padding-top: 0px;\n}\n.padding-top-5px {\n    padding-top: 5px;\n}\n.padding-top-10px {\n    padding-top: 10px;\n}\n.padding-top-15px {\n    padding-top: 15px;\n}\n.padding-top-20px {\n    padding-top: 20px;\n}\n.padding-top-50px {\n    padding-top: 50px;\n}\n\n.padding-bottom-0px {\n    padding-bottom: 0px;\n}\n.padding-bottom-5px {\n    padding-bottom: 5px;\n}\n.padding-bottom-10px {\n    padding-bottom: 10px;\n}\n.padding-bottom-15px {\n    padding-bottom: 15px;\n}\n.padding-bottom-20px {\n    padding-bottom: 20px;\n}\n.padding-bottom-25px {\n    padding-bottom: 25px;\n}\n.padding-bottom-30px {\n    padding-bottom: 30px;\n}\n.padding-bottom-50px {\n    padding-bottom: 50px;\n}\n\n.padding-left-0px {\n    padding-left: 0px;\n}\n.padding-left-5px {\n    padding-left: 5px;\n}\n.padding-left-10px {\n    padding-left: 10px;\n}\n.padding-left-15px {\n    padding-left: 15px;\n}\n.padding-left-20px {\n    padding-left: 20px;\n}\n.padding-left-50px {\n    padding-left: 50px;\n}\n\n.padding-right-0px {\n    padding-right: 0px;\n}\n.padding-right-5px {\n    padding-right: 5px;\n}\n.padding-right-10px {\n    padding-right: 10px;\n}\n.padding-right-15px {\n    padding-right: 15px;\n}\n.padding-right-20px {\n    padding-right: 20px;\n}\n.padding-right-50px {\n    padding-right: 50px;\n}\n\n/* Margin */\n\n.margin-0px {\n    margin: 0px;\n}\n.margin-5px {\n    margin: 5px;\n}\n.margin-10px {\n    margin: 10px;\n}\n.margin-15px {\n    margin: 15px;\n}\n.margin-20px {\n    margin: 20px;\n}\n.margin-50px {\n    margin: 50px;\n}\n\n.margin-top-0px {\n    margin-top: 0px;\n}\n.margin-top-5px {\n    margin-top: 5px;\n}\n.margin-top-10px {\n    margin-top: 10px;\n}\n.margin-top-15px {\n    margin-top: 15px;\n}\n.margin-top-20px {\n    margin-top: 20px;\n}\n.margin-top-50px {\n    margin-top: 50px;\n}\n\n.margin-bottom-0px {\n    margin-bottom: 0px;\n}\n.margin-bottom-5px {\n    margin-bottom: 5px;\n}\n.margin-bottom-10px {\n    margin-bottom: 10px;\n}\n.margin-bottom-15px {\n    margin-bottom: 15px;\n}\n.margin-bottom-20px {\n    margin-bottom: 20px;\n}\n.margin-bottom-50px {\n    margin-bottom: 50px;\n}\n\n.margin-left-0px {\n    margin-left: 0px;\n}\n.margin-left-5px {\n    margin-left: 5px;\n}\n.margin-left-10px {\n    margin-left: 10px;\n}\n.margin-left-15px {\n    margin-left: 15px;\n}\n.margin-left-20px {\n    margin-left: 20px;\n}\n.margin-left-50px {\n    margin-left: 50px;\n}\n\n.margin-right-0px {\n    margin-right: 0px;\n}\n.margin-right-5px {\n    margin-right: 5px;\n}\n.margin-right-10px {\n    margin-right: 10px;\n}\n.margin-right-15px {\n    margin-right: 15px;\n}\n.margin-right-20px {\n    margin-right: 20px;\n}\n.margin-right-50px {\n    margin-right: 50px;\n}\n\n.margin-auto {\n    margin: auto;\n}\n.margin-x-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n.margin-y-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n.margin-top-auto {\n    margin-top: auto;\n}\n.margin-bottom-auto {\n    margin-bottom: auto;\n}\n.margin-left-auto {\n    margin-left: auto;\n}\n.margin-right-auto {\n    margin-right: auto;\n}\n\n/* Text */\n.text-center {\n    text-align: center;\n}\n.text-left {\n    text-align: left;\n}\n.text-right {\n    text-align: right;\n}\n\n.text-decoration-italic {\n    text-decoration: italic;\n}\n.text-decoration-underline {\n    text-decoration: underline;\n}\n.text-decoration-none {\n    text-decoration: none;\n}\n.hover-text-decoration-underline:hover {\n    text-decoration: underline !important;\n}\n.hover-text-decoration-none:hover {\n    text-decoration: none !important;\n}\n\n.text-black {\n    color: #000000;\n}\n.text-white {\n    color: #ffffff;\n}\n.text-danger {\n    color: var(--dangerColorBright);\n}\n\n.line-height-0px {\n    line-height: 0px;\n}\n.line-height-5px {\n    line-height: 5px;\n}\n.line-height-1 {\n    line-height: 1;\n}\n\n.font-size-8px {\n    font-size: 8px !important;\n}\n.font-size-10px {\n    font-size: 10px !important;\n}\n.font-size-12px {\n    font-size: 12px !important;\n}\n.font-size-14px {\n    font-size: 14px !important;\n}\n.font-size-16px {\n    font-size: 16px !important;\n}\n.font-size-18px {\n    font-size: 18px !important;\n}\n.font-size-20px {\n    font-size: 20px !important;\n}\n.font-size-24px {\n    font-size: 24px !important;\n}\n.font-size-28px {\n    font-size: 28px !important;\n}\n.font-size-30px {\n    font-size: 30px !important;\n}\n.font-size-36px {\n    font-size: 36px !important;\n}\n.font-size-40px {\n    font-size: 40px !important;\n}\n.font-size-50px {\n    font-size: 50px !important;\n}\n.font-size-60px {\n    font-size: 60px !important;\n}\n.font-size-70px {\n    font-size: 70px !important;\n}\n.font-size-80px {\n    font-size: 80px !important;\n}\n.font-size-90px {\n    font-size: 90px !important;\n}\n.font-size-100px {\n    font-size: 100px !important;\n}\n.font-size-120px {\n    font-size: 120px !important;\n}\n.font-size-150px {\n    font-size: 150px !important;\n}\n.font-weight-300 {\n    font-weight: 400 !important;\n}\n.font-weight-400 {\n    font-weight: 400 !important;\n}\n.font-weight-500 {\n    font-weight: 500 !important;\n}\n.font-weight-600 {\n    font-weight: 600 !important;\n}\n.font-weight-700 {\n    font-weight: 700 !important;\n}\n.font-weight-800 {\n    font-weight: 800 !important;\n}\n.font-weight-900 {\n    font-weight: 900 !important;\n}\n.font-weight-1000 {\n    font-weight: 1000 !important;\n}\n\n.text-nowrap {\n    white-space: nowrap;\n}\n.text-wrap {\n    white-space: normal;\n}\n\n.text-ellipsis {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.font-display {\n    font-family: \"Red Hat Display\", Outfit, Mulish;\n}\n\n/* Z-index */\n.z-index--3 {\n    z-index: -3;\n}\n.z-index--2 {\n    z-index: -2;\n}\n.z-index--1 {\n    z-index: -1;\n}\n.z-index-0 {\n    z-index: 0;\n}\n.z-index-1 {\n    z-index: 1;\n}\n.z-index-2 {\n    z-index: 2;\n}\n.z-index-3 {\n    z-index: 3;\n}\n.z-index-4 {\n    z-index: 4;\n}\n.z-index-5 {\n    z-index: 5;\n}\n.z-index-10 {\n    z-index: 10;\n}\n.z-index-20 {\n    z-index: 20;\n}\n.z-index-50 {\n    z-index: 50;\n}\n.z-index-100 {\n    z-index: 100;\n}\n\n/* Size */\n.width-fit-content {\n    width: fit-content;\n}\n.width-max-content {\n    width: max-content;\n}\n.width-min-content {\n    width: min-content;\n}\n\n.height-fit-content {\n    height: fit-content;\n}\n.height-max-content {\n    height: max-content;\n}\n.height-min-content {\n    height: min-content;\n}\n\n.min-width-max-content {\n    min-width: max-content;\n}\n.min-width-min-content {\n    min-width: min-content;\n}\n\n.max-width-max-content {\n    max-width: max-content;\n}\n.max-width-min-content {\n    max-width: min-content;\n}\n\n.width-100 {\n    width: 100% !important;\n}\n.width-50 {\n    width: 50%;\n}\n.width-25 {\n    width: 25%;\n}\n\n.height-100 {\n    height: 100%;\n}\n.height-50 {\n    height: 50%;\n}\n.height-25 {\n    height: 25%;\n}\n\n.max-width-100 {\n    max-width: 100%;\n}\n.max-width-50 {\n    max-width: 50%;\n}\n.max-width-25 {\n    max-width: 25%;\n}\n\n.max-width-50px {\n    max-width: 50px;\n}\n.max-width-100px {\n    max-width: 100px;\n}\n.max-width-150px {\n    max-width: 150px;\n}\n.max-width-200px {\n    max-width: 200px;\n}\n.max-width-300px {\n    max-width: 300px;\n}\n.max-width-400px {\n    max-width: 400px;\n}\n.max-width-500px {\n    max-width: 500px;\n}\n\n\n.max-height-100 {\n    max-height: 100%;\n}\n.max-height-50 {\n    max-height: 50%;\n}\n.max-height-25 {\n    max-height: 25%;\n}\n\n.max-height-50px {\n    max-height: 50px;\n}\n.max-height-100px {\n    max-height: 100px;\n}\n.max-height-150px {\n    max-height: 150px;\n}\n.max-height-200px {\n    max-height: 200px;\n}\n.max-height-300px {\n    max-height: 300px;\n}\n.max-height-400px {\n    max-height: 400px;\n}\n.max-height-500px {\n    max-height: 500px;\n}\n\n.min-width-100 {\n    min-width: 100%;\n}\n.min-width-50 {\n    min-width: 50%;\n}\n.min-width-25 {\n    min-width: 25%;\n}\n\n.min-width-50px {\n    min-width: 50px;\n}\n.min-width-100px {\n    min-width: 100px;\n}\n.min-width-150px {\n    min-width: 150px;\n}\n.min-width-200px {\n    min-width: 200px;\n}\n.min-width-300px {\n    min-width: 300px;\n}\n.min-width-400px {\n    min-width: 400px;\n}\n.min-width-500px {\n    min-width: 500px;\n}\n\n\n.min-height-100 {\n    min-height: 100%;\n}\n.min-height-50 {\n    min-height: 50%;\n}\n.min-height-25 {\n    min-height: 25%;\n}\n\n.min-height-50px {\n    min-height: 50px;\n}\n.min-height-100px {\n    min-height: 100px;\n}\n.min-height-150px {\n    min-height: 150px;\n}\n.min-height-200px {\n    min-height: 200px;\n}\n.min-height-300px {\n    min-height: 300px;\n}\n.min-height-400px {\n    min-height: 400px;\n}\n.min-height-500px {\n    min-height: 500px;\n}\n\n.height-inherit {\n    height: inherit;\n}\n.width-inherit {\n    width: inherit;\n}\n.height-auto {\n    height: auto;\n}\n.width-auto {\n    width: auto;\n}\n.height-100vh {\n    height: 100vh;\n}\n.width-100vw {\n    width: 100vw;\n}\n\n.border-box {\n    box-sizing: border-box;\n}\n.content-box {\n    box-sizing: content-box;\n}\n\n/* Custom components */\n\n.select-primary {\n    font-size: 16px;\n    box-sizing: border-box;\n    outline: none;\n    caret-color: rgba(20, 22, 22, 0.564);\n    border:none;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.348);\n    padding: 5px 10px;\n    margin:0;\n    font-family: var(--paragraphFont);\n    background-color: transparent;\n    cursor: pointer;\n}\n\n.input-primary {\n    width: 100%;\n    font-size: 16px;\n    box-sizing: border-box;\n    outline: none;\n    border:none;\n    border-bottom: 2px solid #0005;\n    background-color: transparent;\n    padding: 5px 10px;\n    transition: 0.2s;\n    font-family: var(--paragraphFont);\n}\n.input-primary:focus-visible {\n    border-bottom: 2px solid var(--primaryColorBright);\n    background-image: linear-gradient(0deg, var(--primaryColorUltraTransparent) 10%, #fff0 20%);\n}\n\n.textarea-primary {\n    width: 100%;\n    height: 100px;\n    font-size: 16px;\n    font-weight: 400;\n    border-radius: 7px;\n    outline: none;\n    box-sizing: border-box;\n    padding: 5px 10px;\n    font-family: var(--paragraphFont);\n    resize:vertical;\n    min-height: 3em;\n    transition: border, box-shadow 0.2s;\n    border: 2px solid #0005;\n}\n.textarea-primary:focus-visible {\n    border: 2px solid var(--primaryColorBright);\n    box-shadow: 0 0 1px 3px var(--primaryColorSuperTransparent);\n}\n\n.info-message {\n    border: 2px solid var(--secondaryColorBright);\n    color: var(--secondaryColorBright);\n    border-radius: 8px;\n    padding: 10px;\n    font-size: 14px;\n    font-weight: 500;\n    box-sizing: border-box;\n}\n.error-message {\n    border: 2px solid var(--dangerColorBright);\n    color: var(--dangerColorBright);\n    border-radius: 8px;\n    padding: 10px;\n    font-size: 14px;\n    font-weight: 500;\n    box-sizing: border-box;\n}\n.success-message {\n    border: 2px solid rgb(0, 188, 0);\n    color: rgb(0, 180, 0);\n    border-radius: 8px;\n    padding: 10px;\n    font-size: 14px;\n    font-weight: 500;\n    box-sizing: border-box;\n}\n\n.button-primary, .button-secondary, .button-danger, .button-secondary-dark {\n    border-radius: 1000px;\n    font-weight: 600;\n    font-family: var(--displayFont);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.2s;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n/* All disabled button-primary */\n.button-primary[disabled] {\n    border-radius: 1000px;\n    font-weight: 500;\n    font-family: var(--displayFont);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.1s;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: white;\n    opacity: 0.6;\n    box-shadow: none;\n    cursor: wait;\n    pointer-events: none;\n}\n.button-danger[disabled] {\n    border-radius: 1000px;\n    font-weight: 500;\n    font-family: var(--displayFont);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.1s;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    background-color: transparent;\n    color: white;\n    box-shadow: none;\n    cursor: wait;\n    pointer-events: none;\n}\n.button-secondary[disabled] {\n    border-radius: 1000px;\n    font-weight: 500;\n    font-family: var(--displayFont);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.1s;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    border: 1px solid #00000020;\n    color: #0007;\n    background-color: transparent;\n    box-shadow: none;\n    cursor: wait;\n    pointer-events: none;\n}\n.button-secondary-dark[disabled] {\n    border-radius: 1000px;\n    font-weight: 500;\n    font-family: var(--displayFont);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    border: 1px solid #00000020;\n    color: #fff6;\n    background-color: transparent;\n    box-shadow: none;\n    cursor: default;\n    pointer-events: none;\n}\n\n.button-danger {\n    color: white;\n    background-color: var(--dangerColorBright);\n    background-image: var(--dangerColorGradient);\n    box-shadow: 0px 1px 2px 0px #00000030;\n}\n.button-danger:hover {\n    background-color: var(--dangerColorDark);\n    box-shadow: -1px 2px 3px 1px #00000030;\n}\n\n.button-primary {\n    color: white;\n    background-color: var(--primaryColorBright);\n    background-image: linear-gradient(150deg,\n        var(--primaryColorMediumFaded) 50%,\n        var(--primaryColorDarkFaded) 50%);\n    box-shadow: 0px 1px 4px 1px #00000030;\n}\n.button-primary:hover {\n    background-color: black;\n    box-shadow: 0px 2px 5px 1px #00000040;\n}\n\n.button-secondary {\n    background-color: transparent;\n    background-image: linear-gradient(150deg,\n        #fff2 50%,\n        #7772 50%);\n    border: 1px solid #00000020;\n    box-shadow: 0px 1px 4px 1px #00000020;\n}\n.button-secondary:hover {\n    background-color: #2242;\n    box-shadow: 0px 2px 5px 1px #00000030;\n}\n.button-secondary-dark {\n    background-color: transparent;\n    background-image: linear-gradient(150deg,\n        #fff3 50%,\n        #fff2 50%);\n    color: #fff;\n    border: none;\n    box-shadow: 0px 1px 4px 1px #00000020;\n}\n.button-secondary-dark:hover {\n    background-color: #fff2;\n    box-shadow: 0px 2px 5px 1px #00000030;\n}\n\n.button-mopo {\n    margin: 0;\n    padding: 0;\n}\n.button-small {\n    padding: 3px 10px;\n    font-size: 0.6em;\n    box-sizing: border-box;\n}\n.button-medium {\n    padding: 5px 22px;\n    font-size: 0.75em;\n    box-sizing: border-box;\n}\n.button-large {\n    padding: 8px 27px;\n    font-size: 0.9em;\n    box-sizing: border-box;\n}\n\n.minilabel {\n    width: fit-content;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: var(--paragraphFont);\n    margin-bottom: 5px;\n}\n\n.hover-underline-1px, .hover-underline-2px {\n    position: relative;\n}\n.hover-underline-1px::before, .hover-underline-2px::before {\n    content: '';\n    position: absolute;\n    width: 0;\n    top: 100%;\n    left: 50%;\n    color: inherit;\n    background-color: currentColor;\n    transition: 0.2s cubic-bezier( 0.07, 0.52, 0.08, 0.9 );\n}\n.hover-underline-1px::before {\n    height: 1px;\n}\n.hover-underline-2px::before {\n    height: 2px;\n}\n.hover-underline-1px:hover::before, .hover-underline-2px:hover::before {\n    width: 100%;\n    left: 0;\n}\n.hover-underline-selected::before {\n    width: 100% !important;\n    left: 0;\n}\n\n.link {\n    text-decoration: none;\n    color: var(--linkColor);\n    width: fit-content;\n}\n.link:hover {\n    text-decoration: underline;\n}\n.link-invis {\n    text-decoration: none;\n    color: inherit;\n    width: fit-content;\n    padding: 0;\n    margin: 0;\n}\n.img-link-invis {\n    display: block;\n    font-size: 0;\n    text-decoration: none;\n    color: inherit;\n    width: fit-content;\n}\n\n/* File input that fills the entire button, but is invisible */\n.file-input-invis {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity:0;\n    cursor: pointer;\n}\n\n.centerer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n}\n.center-children {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.mopo {\n    margin: 0;\n    padding: 0;\n}\n\n@keyframes flyin-top {\n    0% {\n        transform: translateY(-50%);\n        opacity: 0.5;\n    }\n    100% {\n        transform: translateY(0%);\n        opacity: 1;\n    }\n}\n.flyin-top {\n    animation: flyin-top 0.2s ease-in-out;\n}\n\n/* Testing */\n.red {\n    background-color: rgba(255, 0, 0, 0.301);\n}\n.green {\n    background-color: rgba(0, 212, 0, 0.307);\n}\n.blue {\n    background-color: rgba(0, 0, 255, 0.303);\n}\n.yellow {\n    background-color: rgba(211, 211, 0, 0.33);\n}\n.purple {\n    background-color: rgba(174, 0, 197, 0.3);\n}\n.orange {\n    background-color: rgba(255, 153, 0, 0.4);\n}\n.pink {\n    background-color: rgba(255, 103, 159, 0.272);\n}\n.cyan {\n    background-color: rgba(0, 203, 193, 0.335);\n}\n.aqua {\n    background-color: rgba(61, 187, 255, 0.248);\n}\n\n/* Positioning */\n.position-relative {\n    position: relative;\n}\n.position-absolute {\n    position: absolute;\n}\n.position-fixed {\n    position: fixed;\n}\n.position-static {\n    position: static;\n}\n.position-sticky {\n    position: sticky;\n}\n\n.float-left {\n    float: left;\n}\n.float-right {\n    float: right;\n}\n.float-none {\n    float: none;\n}\n\n.align-self-start {\n    align-self: flex-start;\n}\n.align-self-center {\n    align-self: center;\n}\n.align-self-end {\n    align-self: flex-end;\n}\n\n.left-0 {\n    left: 0;\n}\n.left-50 {\n    left: 50%;\n}\n.left-100 {\n    left: 100%;\n}\n\n.right-0 {\n    right: 0;\n}\n.right-50 {\n    right: 50%;\n}\n.right-100 {\n    right: 100%;\n}\n\n.top-0 {\n    top: 0;\n}\n.top-50 {\n    top: 50%;\n}\n.top-100 {\n    top: 100%;\n}\n\n/* Display */\n.display-none {\n    display: none;\n}\n.display-block {\n    display: block;\n}\n.display-inline {\n    display: inline;\n}\n.display-inline-block {\n    display: inline-block;\n}\n.display-flex {\n    display: flex;\n}\n.display-inline-flex {\n    display: inline-flex;\n}\n\n/* Shadows */\n.shadow-light {\n    box-shadow: 0px 1px 2px 0px #00000030;\n}\n.shadow-light-2 {\n    box-shadow: -1px 2px 3px 1px #00000030;\n}\n\n.shadow-medium {\n    box-shadow: 0px 1px 3px 0px #00000040;\n}\n.shadow-medium-2 {\n    box-shadow: -1px 2px 5px 1px #00000040;\n}\n\n.shadow-dark {\n    box-shadow: -1px 2px 5px 1px #00000050;\n}\n.shadow-dark-2 {\n    box-shadow: -1px 2px 7px 1px #00000050;\n}\n\n/* Quick Images */\n.image-10px {\n    width: 10px;\n    height: 10px;\n}\n.image-15px {\n    width: 15px;\n    height: 15px;\n}\n.image-20px {\n    width: 20px;\n    height: 20px;\n}\n.image-25px {\n    width: 25px;\n    height: 25px;\n}\n.image-30px {\n    width: 30px;\n    height: 30px;\n}\n.image-40px {\n    width: 40px;\n    height: 40px;\n}\n.image-50px {\n    width: 50px;\n    height: 50px;\n}\n.image-75px {\n    width: 75px;\n    height: 75px;\n}\n.image-100px {\n    width: 100px;\n    height: 100px;\n}\n.image-150px {\n    width: 150px;\n    height: 150px;\n}\n.image-200px {\n    width: 200px;\n    height: 200px;\n}\n.image-300px {\n    width: 300px;\n    height: 300px;\n}\n.image-400px {\n    width: 400px;\n    height: 400px;\n}\n.invert-100 {\n    filter: invert(100%);\n}\n\n/* Transition */\n.transition-0-1s {\n    transition: 0.1s;\n}\n.transition-0-2s {\n    transition: 0.2s;\n}\n.transition-0-3s {\n    transition: 0.3s;\n}\n.transition-0-4s {\n    transition: 0.4s;\n}\n.transition-0-5s {\n    transition: 0.5s;\n}\n.transition-0-6s {\n    transition: 0.6s;\n}\n.transition-0-7s {\n    transition: 0.7s;\n}\n.transition-0-8s {\n    transition: 0.8s;\n}\n.transition-0-9s {\n    transition: 0.9s;\n}\n.transition-1s {\n    transition: 1s;\n}\n.transition-2s {\n    transition: 2s;\n}\n.transition-ease {\n    transition-timing-function: ease;\n}\n.transition-ease-in {\n    transition-timing-function: ease-in;\n}\n.transition-ease-out {\n    transition-timing-function: ease-out;\n}\n.transition-ease-in-out {\n    transition-timing-function: ease-in-out;\n}\n.transition-linear {\n    transition-timing-function: linear;\n}\n\n/* Hover styles */\n.cursor-pointer {\n    cursor: pointer;\n}\n.cursor-default {\n    cursor: default;\n}\n.cursor-text {\n    cursor: text;\n}\n.cursor-wait {\n    cursor: wait;\n}\n.cursor-move {\n    cursor: move;\n}\n.cursor-yresize {\n    cursor: ns-resize;\n}\n.cursor-xresize {\n    cursor: ew-resize;\n}\n.hover-scale-1-01:hover {\n    transform: scale(1.01);\n}\n.hover-scale-1-02:hover {\n    transform: scale(1.02);\n}\n.hover-scale-1-03:hover {\n    transform: scale(1.03);\n}\n.hover-scale-1-04:hover {\n    transform: scale(1.04);\n}\n.hover-scale-1-05:hover {\n    transform: scale(1.05);\n}\n.hover-scale-1-1:hover {\n    transform: scale(1.1);\n}\n\n.hover-light-shadow:hover {\n    box-shadow: 0px 1px 2px 0px #00000030;\n}\n.hover-light-shadow-2:hover {\n    box-shadow: -1px 2px 3px 1px #00000030;\n}\n.hover-medium-shadow:hover {\n    box-shadow: 0px 1px 3px 1px #00000040;\n}\n.hover-medium-shadow-2:hover {\n    box-shadow: -1px 2px 5px 1px #00000040;\n}\n.hover-dark-shadow:hover {\n    box-shadow: -1px 2px 5px 1px #00000050;\n}\n.hover-dark-shadow-2:hover {\n    box-shadow: -1px 2px 7px 1px #00000050;\n}\n\n/* Color */\n\n.text-ultra-light {\n    color: #00000040;\n}\n.text-light {\n    color: #00000080;\n}\n.text-faded {\n    color: #000000c0;\n}\n.text-dark {\n    color: #000000;\n}\n\n.background-transparent {\n    background-color: transparent;\n}\n.background-white {\n    background-color: white;\n}\n.background-black {\n    background-color: black;\n}\n\n/* Filters */\n.filter-none {\n    filter: none;\n}\n.filter-grayscale {\n    filter: grayscale(100%);\n}\n.filter-invert {\n    filter: invert(100%);\n}\n.filter-opacity-100 {\n    opacity: 1;\n}\n.filter-opacity-75 {\n    opacity: 0.75;\n}\n.filter-opacity-50 {\n    opacity: 0.5;\n}\n.filter-opacity-25 {\n    opacity: 0.25;\n}\n.filter-opacity-0 {\n    opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
